var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUserInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-user-inactive-1,.cls-user-inactive-2{fill:none;}\n            .cls-user-inactive-1{clip-rule:evenodd;}\n            .cls-user-inactive-3{clip-path:url(#clip-path_user_inactive);}\n            .cls-user-inactive-4{clip-path:url(#clip-path_user_inactive-2);}\n            .cls-user-inactive-5{fill:#ff0303;}\n        "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path_user_inactive"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-user-inactive-1",
    d: "M13.21,3.36A4.74,4.74,0,0,0,6.85,5.75a5.69,5.69,0,0,0,0,3.82,4.77,4.77,0,0,0,5.91,2.55,5.28,5.28,0,0,0,2.6-2.33,5.47,5.47,0,0,0,.26-3.72A5.51,5.51,0,0,0,13.21,3.36Zm-2.93-2.1a6.33,6.33,0,0,1,6.33,2.93,6.52,6.52,0,0,1-1.54,8.6A5.34,5.34,0,0,1,11.16,14a4.12,4.12,0,0,1-2.68-.54,6.45,6.45,0,0,1,1.8-12.2ZM22.69,10,24,11.27l-2,2,2,1.93-.56.58a2.15,2.15,0,0,1-.74.57,4.94,4.94,0,0,1-1.06-.9l-.9-.91-.95.92-.94.94-.63-.5c-.35-.29-.62-.57-.62-.67a4.82,4.82,0,0,1,.91-1.07l.92-.89-.92-.92a5.77,5.77,0,0,1-.91-1.06,2.68,2.68,0,0,1,.56-.71l.57-.58,2,2Zm-19,2.4h0c0,.06.28.39.49.7l.38.57-.79.76c-1.72,1.66-2,2.68-2,7,0,2.67,0,3.18.23,3.38S3,25,8.77,25h3.6c5.94,0,8-.05,8.07-.17a10.13,10.13,0,0,0,.18-3V19H22.4v3.26c0,3.12-.15,3.54-1.14,4.16l-.57.36-9,0H8c-3.68,0-5.62-.05-6-.13a2.07,2.07,0,0,1-1.3-.74C.16,25.36,0,25,0,23.11v-.42c0-.53,0-1.15,0-1.9a15.26,15.26,0,0,1,.33-4l0-.18a8.49,8.49,0,0,1,2.33-3.51c.48-.43.91-.74,1-.67Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path_user_inactive-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-user-inactive-2",
    x: -1450.01,
    y: -301.8,
    width: 1528.01,
    height: 860.01
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-user-inactive-3"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-user-inactive-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-user-inactive-5",
    x: -1,
    y: -0.06,
    width: 26,
    height: 27.86
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-user-inactive-2",
    x: -785,
    y: -79.5,
    width: 1528,
    height: 860
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserInactive);
export default __webpack_public_path__ + "static/media/icon_user_inactive.3f86e33f5fd8ca37156faaddbab6d398.svg";
export { ForwardRef as ReactComponent };